import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import type { GetTaxonomicGroupsResponse } from "./type";

async function getTaxonomicGroups(
  query: GetQueries,
): Promise<GetTaxonomicGroupsResponse> {
  const params = new URLSearchParams();

  if (query.page) params.append("page", String(query.page));
  if (query.limit) params.append("limit", String(query.limit));
  if (query.search) params.append("search", query.search);

  const url = `${apiPaths.taxonomicGroups.list}?${params.toString()}`;
  const response = await apiClient.get<GetTaxonomicGroupsResponse>(url);

  return response.data;
}

export function useGetTaxonomicGroups(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    query ? [`fetch-get-taxonomic-groups`, query] : null,
    () => (query ? getTaxonomicGroups(query) : null),
    mergedOptions,
  );
}
